import {useEffect, useState} from 'react';
import {
    Button,
    Input,
    FormControl,
    FormLabel,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
} from '@chakra-ui/react';
import {apiService} from 'services/ApiService';
import {useQueryClient} from 'react-query';

const WinnerEditModal = ({ isOpen, onClose, id, initialValues = {}, prizeTitle: initialPrizeTitle = '' }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [prizeTitle, setPrizeTitle] = useState('');

    const queryClient = useQueryClient();

    useEffect(() => {
        if (isOpen) {
            setFirstName(initialValues.firstName || '');
            setLastName(initialValues.lastName || '');
            setEmail(initialValues.email || '');
            setPrizeTitle(initialPrizeTitle || '');
        }
    }, [isOpen, initialValues, initialPrizeTitle]);

    const  handleSubmit = async () => {
        await  apiService.updateGiveawayWinner({id, firstName, lastName, prizeTitle });
        queryClient.invalidateQueries(['giveawayWinners']);
        queryClient.invalidateQueries(['giveawayLogs']);
        setFirstName('');
        setLastName('');
        setEmail('');
        setPrizeTitle('');
        onClose();
    };

    const handleClose = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPrizeTitle('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit Winner</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel>First Name</FormLabel>
                        <Input
                            placeholder='First name'
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </FormControl>

                    <FormControl mb={4}>
                        <FormLabel>Last Name</FormLabel>
                        <Input
                            placeholder='Last name'
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                    </FormControl>
                    <FormControl mb={4}>
                        <FormLabel>Email</FormLabel>
                        <Input
                            isDisabled
                            placeholder='Email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Prize Title</FormLabel>
                        <Input
                            placeholder='Prize title'
                            value={prizeTitle}
                            onChange={(e) => setPrizeTitle(e.target.value)}
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button  variant="submit" mr={3} onClick={handleSubmit}>
                        Submit
                    </Button>
                    <Button variant='ghost' onClick={handleClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default WinnerEditModal;
